export default "__VITE_ASSET__DHX5UZsj__"